<template>
  <div id="map" style="width: 100%; height: 100%"></div>
</template>

<script>
import boatNow from '@/../static/images/boatNow.png'
import util from '@/common/util'
import { SHIP_KEY } from '@/common/config'
import { queryOrderShipTrajectoryInfo } from '@/api/orderCenter'

let _map = null
let marker = null
export default {
  props: ['id'],
  data () {
    return {
      searchForm: {
        ais: '',
        name: ''
      }
    }
  },
  methods: {
    initData () {
      queryOrderShipTrajectoryInfo({ id: this.id }).then(rsp => {
        console.log(rsp.data.showType) // 1未启航显示船定位坐标， 2轨迹图

        if (rsp.data.trajectoryJson) {
          const json = JSON.parse(rsp.data.trajectoryJson)

          const t = rsp.data.showType
          if (t === 1) {
            this.searchForm.ais = json[0].mmsi
            this.handleSubmit1(json)
          } else if (t === 2) {
            this.handleSubmit2(json)
          }
        }
      })
    },
    handleSubmit1 (json) {
      if (_map) _map.trackService.removeAll()
      if (marker) marker.remove()
      let ship = null
      if (json && json.length && json[0].mmsi) {
        ship = util.formatShipdata(json[0])
      }
      var html = ''
      if (ship == null) {
        this.$message.error('没找到船数据')
      } else {
        html += "<div class='box'>"
        html += "   <div class='title'>" + '船名：' + (this.searchForm.name || ship.name) + '</div>'
        html += "   <div class='field'>" + '呼号：' + ship.callsign + '</div>'
        html += "   <div class='field'>" + 'IMO: ' + ship.imo + '</div>'
        html += "   <div class='field'>" + 'MMSI: ' + ship.mmsi + '</div>'
        html += "   <div class='field'>" + '船长：' + ship['length'] + '米' + '</div>'
        html += "   <div class='field'>" + '船宽：' + ship.width + '米' + '</div>'
        html += "   <div class='field'>" + '吃水：' + ship.draught + '米' + '</div>'

        // eslint-disable-next-line no-undef
        const commUtils = CommUtils
        // eslint-disable-next-line no-undef
        const canvasShipUtils = CanvasShipUtils
        html += "   <div class='field'>" + '航速：' + commUtils.getNumber(ship.sog, 0) + '节' + '</div>'
        html += "   <div class='field'>" + '船首向：' + commUtils.getNumber(ship.hdg, 1) + '度' + '</div>'
        html += "   <div class='field'>" + '航迹向：' + commUtils.getNumber(ship.cog, 1) + '度' + '</div>'
        html += "   <div class='field'>" + '经纬度：' + canvasShipUtils.latlngFormatter([ship.lat, ship.lon]) + '</div>'
        html += "   <div class='field'>" + '类型：' + canvasShipUtils.getShipTypeCN(ship.shiptype) + '</div>'
        html += "   <div class='field'>" + '航行状态：' + canvasShipUtils.getDisValue(ship.navistat, 'naviStatus', 'zh_CN') + '</div>'
        html += "   <div class='field'>" + '更新时间：' + commUtils.dataFormat(new Date(ship.lasttime), 'yyyy-MM-dd hh:mm:ss') + '</div>'
        html += '</div>'
      }
      // eslint-disable-next-line no-undef
      _map.openPopup(html, ShipxyAPI.latLng(ship.lat, ship.lon), { className: 'shipxy_popup' })

      // 自定义图标
      // eslint-disable-next-line no-undef, camelcase
      var marker_icon_1 = L.icon({
        iconUrl: boatNow,
        iconAnchor: [10, 10], // 图标锚点
        iconSize: [21, 21]// 图标大小
      })
      // 添加标记,到地图
      // eslint-disable-next-line no-undef
      marker = ShipxyAPI.marker([ship.lat / 1000000, ship.lon / 1000000], {
        icon: marker_icon_1
      }).addTo(_map)
    },
    handleSubmit2 (json) {
      if (_map) _map.trackService.removeAll()
      var options = {
        lineColor: 'tomato', // 线，颜色
        lineWeight: 2, // 线，粗细
        dash: true, // 是否为虚线
        dashArray: [5, 5], // 虚线间隔
        circleOverColor: 'yellow', // 轨迹点,鼠标划过时颜色
        isDilute: true // 是否抽稀模式显示
      }
      let tracks = []
      // 轨迹数据(测试数据)
      for (var i = 0; i < json.length; i++) {
        // eslint-disable-next-line no-undef
        var track = new Track()
        const t = json[i]
        track.hdg = t.cog / 100 // 航首向，正常值 百分之一
        track.utc = t.utc // （必填）
        track.sog = t.sog / 100000 // （必填） 航速，正常值 毫米/秒,
        track.lng = t.lon / 1000000 // （必填）百万分之一
        track.lat = t.lat / 1000000 // （必填）百万分之一
        tracks.push(track)
      }
      // 添加并显示轨迹
      _map.trackService.addAndShow('', tracks, options, { 'mmsi': this.searchForm.ais })
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.title = '航行轨迹图'
      // 创建地图示例
      // eslint-disable-next-line no-undef
      _map = new ShipxyAPI.Map('map', { ak: SHIP_KEY })
      // 开启轨迹服务
      // eslint-disable-next-line no-undef
      ShipxyAPI.TrackService(_map)
      // eslint-disable-next-line no-undef
      ShipxyAPI.ShipService(_map, {
        enableAreaShip: false, // 区域船
        enableFleetShip: false // 船队船
      })

      this.initData()

      this.searchForm.name = this.$route.path.query ? this.$route.path.query.replace('?s=', '') : ''
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/page/orderTackH5.vue